<template>
  <div
    v-if="hasPermission || $slots.noPermission || $slots.noAgent"
    :class="$attrs.class ? '' : 'contents'"
  >
    <div
      v-if="hasPermission"
      :class="{ 'bg-orange px-2 py-1 rounded-lg': !noAgentInfo }"
    >
      <strong v-if="!noAgentInfo">
        Agent&nbsp;
      </strong>
      <slot />
    </div>

    <slot
      v-else
      name="noPermission"
    />

    <slot
      v-if="!agentCookie"
      name="noAgent"
    />
  </div>
</template>

<script>
import { mapState } from 'pinia'

export default defineNuxtComponent({
  props: {
    /**
     * List of keys to be truthy in the agentCookie object
     */
    requiredPermissions: {
      type: Array,
      default: () => [],
    },

    noAgentInfo: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(useRootStore, ['agentCookie']),

    hasPermission () {
      return (
        this.agentCookie &&
        this.requiredPermissions.every(agentCookieKey => !!this.agentCookie[agentCookieKey])
      )
    },
  },
})
</script>
